import React from "react";
import { Text as ChakraText } from "@chakra-ui/react";
export function Text({ isMonospace, size = "md", ...props }) {
    return (React.createElement(ChakraText, { as: "span", fontSize: size, fontFamily: isMonospace ? "mono" : undefined, ...props }));
}
